/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentGeometryGeometriesInnerOneOf3
 */
export interface EquipmentGeometryGeometriesInnerOneOf3 {
    /**
     * 
     * @type {EquipmentGeometryGeometriesInnerOneOf3TypeEnum}
     * @memberof EquipmentGeometryGeometriesInnerOneOf3
     */
    type: EquipmentGeometryGeometriesInnerOneOf3TypeEnum;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof EquipmentGeometryGeometriesInnerOneOf3
     */
    coordinates: Array<Array<number>>;
}


/**
 * @export
 */
export const EquipmentGeometryGeometriesInnerOneOf3TypeEnum = {
    MultiPoint: 'MultiPoint'
} as const;
export type EquipmentGeometryGeometriesInnerOneOf3TypeEnum = typeof EquipmentGeometryGeometriesInnerOneOf3TypeEnum[keyof typeof EquipmentGeometryGeometriesInnerOneOf3TypeEnum];


/**
 * Check if a given object implements the EquipmentGeometryGeometriesInnerOneOf3 interface.
 */
export function instanceOfEquipmentGeometryGeometriesInnerOneOf3(value: object): value is EquipmentGeometryGeometriesInnerOneOf3 {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'MultiPoint') return false;
    
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function EquipmentGeometryGeometriesInnerOneOf3FromJSON(json: any): EquipmentGeometryGeometriesInnerOneOf3 {
    return EquipmentGeometryGeometriesInnerOneOf3FromJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf3FromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentGeometryGeometriesInnerOneOf3 {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function EquipmentGeometryGeometriesInnerOneOf3ToJSON(json: any): EquipmentGeometryGeometriesInnerOneOf3 {
    return EquipmentGeometryGeometriesInnerOneOf3ToJSONTyped(json, false);
}

export function EquipmentGeometryGeometriesInnerOneOf3ToJSONTyped(value?: EquipmentGeometryGeometriesInnerOneOf3 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

